document.addEventListener("DOMContentLoaded", function () {
  console.log("🚀 Custom cart JS loaded");

  // ✅ Refresh cart page footer only
  function refreshCartPageFooter() {
    const footer = document.querySelector("#main-cart-footer");
    if (!footer) return; // Not on cart page

    fetch(window.location.pathname + "?sections=main-cart-footer")
      .then(res => res.json())
      .then(data => {
        if (data["main-cart-footer"]) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data["main-cart-footer"], "text/html");
          const newCtas = doc.querySelector(".cart__ctas");
          const currentCtas = document.querySelector(".cart__ctas");
          if (newCtas && currentCtas) {
            currentCtas.innerHTML = newCtas.innerHTML;
          }
        }
      })
      .catch(err => console.error("Cart page footer refresh error:", err));
  }

  // Listen for Shopify events
  document.addEventListener("cart:updated", refreshCartPageFooter);
  document.addEventListener("cart:change", refreshCartPageFooter);

  // Fallback: watch for +/- clicks
  document.body.addEventListener("click", function (e) {
    if (e.target.closest(".quantity__button")) {
      setTimeout(refreshCartPageFooter, 800);
    }
  });

  // Watch for input changes
  document.body.addEventListener("change", function (e) {
    if (e.target.matches('[name="updates[]"]')) {
      setTimeout(refreshCartPageFooter, 800);
    }
  });
});